module.exports = __webpack_public_path__ + "h5/img/home11.7f5cbe2e.png";